import { NameValuePair } from '../data-models/name-value-pair';


export class LgvSettings {
    theme: string;
    businessType: string;
    selectedCompany: string;
    showRefinanceOptions: boolean = true;
    showRealEstateOptions: boolean = true;

    static AvailableThemes(): NameValuePair[] {
        return [
            { name: 'Default', value: 'default-theme' },
            { name: 'Light', value: 'light-theme' },
            { name: 'Nature', value: 'nature-theme' },
            { name: 'Test', value: 'test-theme' },
            { name: 'Dark', value: 'black-theme' }
        ];
    }

    static SupportedBusinessTypes(): NameValuePair[] {
        return [
            { name: 'Loan Agent', value: 'loan-agent' },
            { name: 'Realtor', value: 'realtor' }
        ];
    }

    static WhiteLabeledCompanyList(): NameValuePair[] {
        return [
            { name: 'RPM Mortgage', value: '6' },
            { name: 'Compass', value: '10' },
            { name: 'LendUS', value: '7' }
        ];
    }
}

